import { useAppSelector } from '../../../data/store';
import { PaymentTabsEnum } from '../../../enums/payment-tabs-enum';
import { checkIsSubscription } from '../../../domain/shopping-cart-provider';
import PaymentTab from './payment-tab';
import { ICartData } from '../../../interfaces';
import { getIsChina } from '../../../../../../domain/hidden-data-provider';
import { getEnabledPaymentTypes } from '../../../../cart-shared-bridger-pay/domain/payment-tabs-provider';

const getPaymentTabs = (cartData: ICartData, isApplePayEnabled: boolean, sbsDebitAllowed: boolean): JSX.Element[] => {

    const types: PaymentTabsEnum[] = getEnabledPaymentTypes(getIsChina(), isApplePayEnabled);

    return types.map((paymentType, i) => {
        switch(paymentType) {
            case PaymentTabsEnum.CreditCard: {
                return (
                    <PaymentTab
                        key={ PaymentTabsEnum.CreditCard }
                        type={ PaymentTabsEnum.CreditCard }
                        title={ (checkIsSubscription(cartData) && !sbsDebitAllowed) ? 'Credit Card': 'Credit / Debit Card' }
                        isLast={ i === types.length - 1 }
                    />
                )
            }
            case PaymentTabsEnum.PayPal: {
                return (
                    <PaymentTab
                        key={ PaymentTabsEnum.PayPal }
                        type={ PaymentTabsEnum.PayPal }
                        title="PayPal"
                        isLast={ i === types.length - 1 }
                    />
                )
            }
            case PaymentTabsEnum.ApplePay: {
                return (
                    <PaymentTab
                        key={ PaymentTabsEnum.ApplePay }
                        type={ PaymentTabsEnum.ApplePay }
                        title="Apple Pay"
                        isLast={ i === types.length - 1 }
                    />
                )
            }
            case PaymentTabsEnum.AliPay: {
                return (
                    <PaymentTab
                        key={ PaymentTabsEnum.AliPay }
                        type={ PaymentTabsEnum.AliPay }
                        title="AliPay"
                        isLast={ i === types.length - 1 }
                    />
                )
            }
            default: {
                return (
                    <></>
                )
            }
        }
    })
};

const PaymentTabs = () => {

    const cartData = useAppSelector(store => store.root.cartData);
    const isApplePayEnabled = useAppSelector(store => store.root.isApplePayEnabled);
    const sbsDebitAllowed = useAppSelector(store => store.root.sbsDebitAllowed);

    const paymentTypes = getPaymentTabs(cartData, isApplePayEnabled, sbsDebitAllowed);

    return (
        <div className="mb-8">
            <div className="text-gray-500 mb-2">Pay With</div>

            <div className={`border rounded overflow-hidden font-bold text-center text-gray-700 text-tiny pointer grid grid-cols-${ paymentTypes.length }`}>
                { paymentTypes }
            </div>
        </div>
    )
};

export default PaymentTabs;
